import React from 'react';
import { MenuItemArgs } from './types';
import { IconAdd, IconRiskManagement, IconModifier, IconWizard, IconVariable, IconComments } from './icons';
import { Poppins } from 'src/common';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import * as S from './util.styles';

export const ADD_TO_RMP = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="add-to-rmp">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:AddToRMP',
        });
      }}
      onMouseEnter={() => setActiveItem('add-to-rmp')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-add-to-rmp"
    >
      <div className="icon-container">
        <IconRiskManagement isActive={activeItem === 'add-to-rmp'} />
      </div>
      <Poppins px={16}>{label || 'Add to RMP'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const EXEC_SUMMARY = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="exec-summary">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:ExecutiveSummary',
        });
      }}
      onMouseEnter={() => setActiveItem('exec-summary')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-exec-summary"
    >
      <div className="icon-container">
        <IconAdd isActive={activeItem === 'exec-summary'} />
      </div>
      <Poppins px={16}>{label || 'Executive Summary'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const OPEN_MODIFIER = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="open-modifier">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:OpenModifier',
        });
      }}
      onMouseEnter={() => setActiveItem('open-modifier')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-open-modifier"
    >
      <div className="icon-container">
        <IconModifier isActive={activeItem === 'open-modifier'} />
      </div>
      <Poppins px={16}>{label || 'Open Modifier'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const ADD_CONTROL = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="add-control">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:AddControl',
        });
      }}
      onMouseEnter={() => setActiveItem('add-control')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-add-control"
    >
      <div className="icon-container">
        <IconAdd isActive={activeItem === 'add-control'} />
      </div>
      <Poppins px={16}>{label || 'Add Control'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const ADD_ASSESSMENT = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="add-assessment">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:AddAssessment',
        });
      }}
      onMouseEnter={() => setActiveItem('add-assessment')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-add-assessment"
    >
      <div className="icon-container">
        <IconAdd isActive={activeItem === 'add-assessment'} />
      </div>
      <Poppins px={16}>{label || 'Assessment'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const ADD_STRATEGY = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="add-strategy">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:AddStrategy',
        });
      }}
      onMouseEnter={() => setActiveItem('add-strategy')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-add-strategy"
    >
      <div className="icon-container">
        <IconAdd isActive={activeItem === 'add-strategy'} />
      </div>
      <Poppins px={16}>{label || 'Add Strategy'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const ADD_INCIDENT = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="add-incident">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:AddIncident',
        });
      }}
      onMouseEnter={() => setActiveItem('add-incident')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-add-incident"
    >
      <div className="icon-container">
        <IconAdd isActive={activeItem === 'add-incident'} />
      </div>
      <Poppins px={16}>{label || 'Add Incident'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const WIZARD = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="wizzard">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:AddAssessment',
        });
      }}
      onMouseEnter={() => setActiveItem('wizzard')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-wizzard"
    >
      <div className="icon-container">
        <IconWizard isActive={activeItem === 'wizzard'} />
      </div>
      <Poppins px={16}>{label || 'Assessment Wizard'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const WORKSPACE_VARIABLES = ({
  label,
  exe,
  divider,
  resetActiveItem,
  activeItem,
  setActiveItem,
}: MenuItemArgs) => (
  <div key="add-vw">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:WorkspaceVariables',
        });
      }}
      onMouseEnter={() => setActiveItem('add-vw')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-add-vw"
    >
      <div className="icon-container">
        <IconVariable isActive={activeItem === 'add-vw'} />
      </div>
      <Poppins px={16}>{label || 'Workspace Variables'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const MARK_AS_COMPLETED = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="mark-as-completed">
    <S.Item
      onClick={exe}
      onMouseEnter={() => setActiveItem('mark-as-completed')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-mark-as-completed"
    >
      <div className="icon-container">
        <IconAdd isActive={activeItem === 'mark-as-completed'} />
      </div>
      <Poppins px={16}>{label || 'Mark as Done'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const ADD_ACTION = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="add-action">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:AddAction',
        });
      }}
      onMouseEnter={() => setActiveItem('add-action')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-add-action"
    >
      <div className="icon-container">
        <IconAdd isActive={activeItem === 'add-action'} />
      </div>
      <Poppins px={16}>{label || 'Add Action'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const COMMENTS = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="comments">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:Comments',
        });
      }}
      onMouseEnter={() => setActiveItem('comments')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-comments"
    >
      <div className="icon-container">
        <IconComments isActive={activeItem === 'comments'} />
      </div>
      <Poppins px={16}>{label || 'Comments'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);
